import axios from 'axios'
export default class EstadosCidadesService {
 
    getEstadosCidades() {
        return axios.get('assets/data/estados-cidades.json').then(res => res.data.data);
    }

}
